import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Subscription } from 'rxjs/Subscription';
import { LogService } from '../../../services/shared/log.service';
import { NGaugeService } from '../../../services/shared/ngauge.service';
import { PubSubService } from '../../../services/shared/pub-sub.service';
import { TechService } from '../../../services/tech.service';
import { UserService } from '../../../services/user.service';
import { ADD_PAGE, CORPORATE, EDIT_PAGE, LOG_LEVELS, LOG_MESSAGES, PLUS_CLICK, TEXT_AREA_TOOL_TIP, VIEW_PAGE } from '../../../util/constants';
import { AuthService } from '../../../services/shared/auth.service';

@Component({
  selector: 'app-ask-question',
  templateUrl: './ask-question.component.html',
  styleUrls: []
})

export class AskQuestionComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild('askQuesSort') askQuesSort: MatSort;
  @Input() editValue;
  panelOpenState1: any;
  panelOpenState2: any;
  dataSource: MatTableDataSource<any>;
  displayColumns = ['Title', 'Status', 'Action'];
  askQuestionForm: FormGroup;
  statusValues = ['New', 'Asked', 'Answered'];
  selectedIndex = 0;
  tabTitle = '';
  viewMode = '';
  filteredStatus: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  statusFilterCtrl: FormControl = new FormControl();
  answer = '';
  ask: any;
  propertyAskId: any;
  isLoading = true;
  saveClicked = false;
  textToolTip = TEXT_AREA_TOOL_TIP;
  is_a_superadmin:boolean=false;
  dialogCloseSubscription: Subscription;
  updateGradeSubscription: Subscription;
  saveQuestionSubscription: Subscription;
  getAskQuestionSubscription: Subscription;
  getquestionByIdSubscription: Subscription;
  currentissue:any;
  constructor(
    private ngaugeService: NGaugeService,
    private formBuilder: FormBuilder,
    private logService: LogService,
    private pubSubService: PubSubService,
    private userService: UserService,
    private authservice :AuthService,
    private techService: TechService) {
    this.logUserActivity('Ask Question', LOG_MESSAGES.CLICK);
  }

  ngOnInit() {
    this.buildStatusDropdown();
    this.askQuestionForm = this.buildForm();
    this.tabTitle = '';
    this.is_superadmin();
  }

  ngAfterViewInit() {
    if (this.ngaugeService.checkForNllUndef(this.editValue)) {
      this.saveClicked = false;
      this.propertyAskId = Number(this.editValue['value']);
      this.getquestionByIdSubscription = this.techService.getQuestionByPropertyId(this.propertyAskId,
        this.editValue['property']).subscribe(response => {
          if (this.editValue['view'] === EDIT_PAGE) {
            this.askQuestionForm.get('answer').setValidators([Validators.required, Validators.maxLength(512)]);
            this.askQuestionForm.get('status').setValue('Answered');
            this.editAskQuestion(response[0]);
          } else {
            this.viewIssue(response[0]);
          }
        });
    }
    this.getAskQuestion();
  }

  getAskQuestion() {
    this.dataSource = new MatTableDataSource([]);
    const params = this.techService.getFilterParams('answerOn');
    this.getAskQuestionSubscription = this.techService.getAskQuestion(params).subscribe(data => {
      this.setDataSource(data, this.paginator, this.askQuesSort);
      this.getAskQuestionSubscription.unsubscribe();
    }, error => {
      this.logService.logError(LOG_LEVELS.ERROR, 'Ask Question', 'On fetch report issues', JSON.stringify(error));
    });
  }

  setDataSource(data: any, paginator: MatPaginator, sort: MatSort) {
    this.dataSource = this.techService.getMatTable(data, paginator, sort);
    this.isLoading = false;
  }

  buildStatusDropdown() {
    this.ngaugeService.buildFilter(this.statusFilterCtrl, this.filteredStatus, this.statusValues, '');
  }

  addReportIssue() {
    this.saveClicked = false;
    this.viewMode = ADD_PAGE;
    this.answer = '';
    this.tabTitle = this.viewMode + ' Ask Question';
    this.askQuestionForm = this.buildForm();
    this.askQuestionForm.get('status').patchValue('New');
    this.selectedIndex = 1;
    this.logUserActivity('Ask Question', PLUS_CLICK);
    setTimeout(() => {
      this.askQuestionForm.get('answer').setErrors(null);
    }, 200);
  }

  changeTabs(tabName) {
    this.logUserActivity('Ask Question', tabName);
    if (tabName === 'Ask') {
      this.selectedIndex = 0;
      this.getAskQuestion();
    }
    this.logUserActivity('Ask Question', tabName);
  }

  buildForm() {
    return this.formBuilder.group({
      about: ['', [Validators.required, Validators.maxLength(30), Validators.minLength(3)]],
      elaborate: ['', [Validators.required, Validators.maxLength(512), Validators.minLength(3)]],
      status: ['', Validators.required],
      answer: ['']
    });
  }

  editAskQuestion(issue) {
    this.currentissue=issue;
    if (this.ngaugeService.checkForNllUndef(issue['propertyaskId'])) {
      this.propertyAskId = issue['propertyaskId'];
    }
    this.ask = issue;
    this.saveClicked = false;
    this.viewMode = EDIT_PAGE;
    this.answer= this.currentissue.answer;
    this.askQuestionForm.addControl('property', new FormControl(issue.property));
    this.askQuestionForm.addControl('SID', new FormControl(issue.SID));
    this.tabTitle = this.viewMode + ' Ask Question';
    this.formatView(issue);
    this.logUserActivity('Ask Question - Edit', issue.about);
  }

  formatView(issue) {
    this.askQuestionForm.addControl('id', new FormControl(issue.id));
    this.askQuestionForm.patchValue(issue);
    this.selectedIndex = 1;
    this.isLoading = false;
  }

  viewIssue(issue) {
    this.viewMode = VIEW_PAGE;
    this.tabTitle = this.viewMode + ' Ask Question';
    this.formatView(issue);
    this.logUserActivity('Ask Question - View', issue.about);
  }

  gettAskQuestion(id, viewType) {
    this.getquestionByIdSubscription = this.techService.getQuestionById(id).subscribe(response => {
      this.answer = response[0]['answer'];
      switch (viewType) {
        case 'edit': this.editAskQuestion(response[0]); break;
        case 'view': this.viewIssue(response[0]); break;
        case 'grade': this.updateGrade(response[0]); break;
      }
    });
  }

  save(value) {
    this.saveClicked = true;
    this.logUserActivity('Ask Question - Save', LOG_MESSAGES.CLICK);
    if (this.askQuestionForm.dirty) {
      if (this.viewMode === ADD_PAGE) {
        value['id'] = 0;
        value['createdBy'] = this.userService.getLoggedInUserId();
        value['property'] = this.userService.getLoggedInUserProperty();
        value['createdName'] = this.userService.getLoggedInUserName();
        value['status'] = 'Asked';
      }
      this.saveQuestion(value);
    } else {
      this.selectedIndex = 0;
      this.tabTitle = '';
    }
  }

  updateValues(question) {
    if (this.viewMode === EDIT_PAGE) {
      question['createdBy'] = this.ask['createdBy'];
    }
    question['createdOn'] = new Date();
    if (this.ngaugeService.checkForNllUndef(this.propertyAskId)) {
      question['propertyaskId'] = this.propertyAskId;
    }
    if (this.askQuestionForm.get('answer').dirty) {
      question['answerBy'] = this.userService.getLoggedInUserId();
    }
    question['answerOn'] = new Date();
    const propertyType = this.userService.getLoggedInPropertyType();
    question['iscorporate'] = propertyType === CORPORATE ? true : false;
    if (question.status === 'New') {
      question['status'] = 'Answered';
    }
    return question;
  }

  saveQuestion(question) {
    question = this.updateValues(question);
    this.saveQuestionSubscription = this.techService.saveAskQuestion(question).subscribe(data => {
      if (data['result']) {
        this.selectedIndex = 0;
        const action = this.viewMode === ADD_PAGE ? 'created' : 'updated';
        this.ngaugeService.toastrSuccess('Ask question ' + action + ' successfully');
        this.tabTitle = '';
        const currentUrl = this.ngaugeService.getCurrentUrl();
        if (currentUrl.includes('helpCenter')) {
          this.pubSubService.publish('help-center-modified');
        }
        this.logUserActivity('Ask Question - Save', LOG_MESSAGES.SUCCESS);
      } else {
        this.saveClicked = false;
        const action = this.viewMode === ADD_PAGE ? 'create' : 'update';
        this.ngaugeService.toastrError('Ask question ' + action + ' failed');
        this.logUserActivity('Ask Question - Save', LOG_MESSAGES.FAILURE);
        this.logService.logError(LOG_LEVELS.DEBUG, 'Ask Question', 'On Add/Edit ask question', JSON.stringify(question));
      }
    }, error => {
      this.saveClicked = false;
      this.logService.logError(LOG_LEVELS.DEBUG, 'Ask Question', 'On Add/Edit ask question', JSON.stringify(error));
    });
  }

  updateGrade(issue) {
    if(issue.SourceID != this.authservice.getSID()){
      this.ngaugeService.toastrError('You cannot grade this Ask');
        this.logUserActivity('Ask Question - Grade', LOG_MESSAGES.FAILURE);
        this.logService.logError(LOG_LEVELS.DEBUG, 'Ask Question', 'On Add/Edit ask question', JSON.stringify(issue));
        return
    }
    this.logUserActivity('Ask Question - Grade', LOG_MESSAGES.CLICK);
    const dialogRef = this.techService.openGradeComponent(issue);
    this.dialogCloseSubscription = dialogRef.afterClosed().subscribe(async result => {
      issue = this.techService.getMoreAttributes(issue, result);
      this.updateGradeSubscription = this.techService.saveAskQuestion(issue).subscribe(() => {
        this.logUserActivity('Ask Question - Grade - Ok', LOG_MESSAGES.CLICK);
        this.ngaugeService.toastrSuccess('Question Updated Successfully');
        setTimeout(() => {
          this.techService.publishCloseSideNavTriggerer('close');
        }, 100);
      }, error => {
        this.logService.logError(LOG_LEVELS.ERROR, 'Ask Question', 'On update grade', JSON.stringify(error));
      });
    });
  }

  logUserActivity(from, value) {
    this.logService.logUserActivity(LOG_LEVELS.INFO, from, value);
  }

  closeAskQuestion() {
    this.techService.publishCloseSideNavTriggerer('close');
    this.logUserActivity('Ask Question', LOG_MESSAGES.CANCEL);
  }

  pasteClipboardContent(fieldName, placeHolder) {
    const action = this.viewMode === EDIT_PAGE ? EDIT_PAGE : ADD_PAGE;
    this.logUserActivity('Ask Question - ' + action, 'Paste ' + placeHolder);
    let preValue = this.askQuestionForm.get(fieldName).value;
    preValue = preValue === null ? '' : preValue;
    this.ngaugeService.getClipboardContent().then(text => {
      this.askQuestionForm.get(fieldName).patchValue(preValue + text);
    });
  }

  unSubscribe(subscription: Subscription) {
    if (this.ngaugeService.checkForNllUndef(subscription)) {
      subscription.unsubscribe();
    }
  }

  ngOnDestroy() {
    this.unSubscribe(this.saveQuestionSubscription);
    this.unSubscribe(this.getAskQuestionSubscription);
    this.unSubscribe(this.getquestionByIdSubscription);
    this.unSubscribe(this.dialogCloseSubscription);
    this.unSubscribe(this.updateGradeSubscription);
    this.editValue = null;
    this.paginator = null;
    this.askQuesSort = null;
    this.panelOpenState1 = null;
    this.panelOpenState2 = null;
    this.dataSource = null;
    this.displayColumns = null;
    this.askQuestionForm = null;
    this.statusValues = null;
    this.selectedIndex = null;
    this.tabTitle = null;
    this.viewMode = null;
    this.isLoading = null;
    this.propertyAskId = null;
    this.saveClicked = null;
    this.ngaugeService = null;
    this.formBuilder = null;
    this.logService = null;
    this.pubSubService = null;
    this.userService = null;
    this.techService = null;
    this.filteredStatus = null;
    this.statusFilterCtrl = null;
    this.textToolTip = null;
  }
  answered(){
    if(this.currentissue=="Answered"){
      return true;
    }
    else{
      return false;
    }
  }

  checksaveconditions(){ //if the ask is new no condition to save if not only ansering person(superadmin from ymc can save)
    let user=JSON.parse(sessionStorage.getItem('$$NGauge-UserInfo$$'));
    if((this.viewMode==='Add'|| this.viewMode==='Edit') && (this.answer===''|| this.currentissue.status !=="Answered")){
      if(this.viewMode==='Add'){
        return true
      }
      else{
        if(user.userType=="SuperAdmin" && this.authservice.getSID()=='3'){
          return true
        }
        else{
          return false
        }
  
      }
    }
    else{
      return false
    }
   
   
  }
  is_superadmin(){
    let user=JSON.parse(sessionStorage.getItem('$$NGauge-UserInfo$$'));
    if(user.userType=="SuperAdmin" && this.authservice.getSID()=='3'){
      this.is_a_superadmin=true
    }
  }
}





// WEBPACK FOOTER //
// ./src/app/core/tech-support/ask-question/ask-question.component.ts